import AppRoutes from "./Apps";

// ** Document title
const TemplateTitle = '%s - The School Bridge'

// ** Default Route
const DefaultRoute = '/'

// ** Merge Routes
const RoutesData = [...AppRoutes]

export { DefaultRoute, TemplateTitle, RoutesData }